import type { BranchResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toBranch } from './toBranch';

// Builds a normalized `Data.Branch` domain from a list of Branch DTOs.
function toBranchDomain(args: { dtos: BranchResponse[] }) {
  const { dtos } = args;

  const branchDomain: NormalizedDomain<Data.Branch> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const branch = toBranch(item);
      domainUtility.mutateAdd(branchDomain, branch);
    },
  });

  return { branchDomain };
}

export { toBranchDomain };
